import { UniversalCart } from '../../scripts/blocks/store/cart/UniversalCart';
import { showLoaderCartButton } from './show-loader-cart-button';

export const selectQuantity =
  ({ cart, sku }: { cart: UniversalCart; sku: string }) =>
  async (value: string | number) => {
    const loader = showLoaderCartButton(
      document.querySelectorAll(
        `[data-sku="${sku}"][data-button-type="cart-select"]`
      )
    );
    loader(true);

    const success = cart.setQuantityBySku(Number(value), sku);
    if (success) {
      await cart.save({
        showPopup: true,
      });
    }

    loader(false);
  };

export const changeSelectedQuantity = (cart: UniversalCart, sku: string) => {
  const selectorsQuantityText = document.querySelectorAll(
    `[data-sku="${sku}"][data-type="select-quantity-item-in-cart"]`
  );
  const item = cart.getItemBySKU(sku);
  if (selectorsQuantityText.length && item) {
    selectorsQuantityText.forEach((select) => {
      select.innerHTML = item.quantity;
    });
  }
};
